module.exports = __webpack_public_path__ + "static/media/KalgoorlieMiner-devicecomp-min.b70690be.webp";